module.exports = __webpack_public_path__ + "static/media/Link buttons_create.9e6ad0c9.png";